import { useData } from "@/context/DataContext";
import { ProjectionSection } from "@/components/dashboard/ProjectionSection";

export default function ProjectionPage() {
  const { leads } = useData();
  return (
    <div className="space-y-5" data-testid="projection-page">
      <div>
        <h1 className="font-display text-2xl font-extrabold tracking-tight sm:text-3xl">Projection</h1>
        <p className="text-sm text-slate-400">End-of-month revenue and cash forecast for the current month (IST).</p>
      </div>
      <ProjectionSection deps={[leads]} />
    </div>
  );
}
